const routes = [
  {
    name: "AuthLayout",
    path: "/auth",
    props: true,
    children: [
      {
        name: "AuthPage",
        path: "",
        component: () => import("../pages/LoginPage.vue"),
        props: true,
      },
      {
        name: "LoginPage",
        path: "login",
        component: () => import("../pages/LoginPage.vue"),
        props: true,
      },
      {
        name: "RegisterPage",
        path: "register",
        component: () => import("../pages/RegisterPage.vue"),
        props: true,
      },
      {
        name: "ForgotPasswordPage",
        path: "forgot-password",
        component: () => import("../pages/ForgotPasswordPage.vue"),
        props: true,
      },
      {
        name: "ResetPasswordPage",
        path: "reset-password/:token",
        component: () => import("../pages/ResetPasswordPage.vue"),
        props: true,
      },
      {
        name: "TwoFactorVerifyPage",
        path: "verify",
        component: () => import("../pages/TwoFactorVerifyPage.vue"),
        props: true,
      },
    ],
  },
  {
    name: "TermsPage",
    path: "/terms",
    props: true,
    children: [
      {
        name: "PrivacyPage",
        path: "privacy-policy",
        component: () => import("../pages/static/PrivacyPage.vue"),
        props: true,
      },
      {
        name: "TermsAndConditionsPage",
        path: "terms-and-conditions",
        component: () => import("../pages/static/TermsAndConditionsPage.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/:catchAll(.*)*",
    name: "404",
    component: () => import("@/_shared/pages/ErrorNotFoundPage.vue"),
  },
];

export default routes;
